module.exports = __webpack_public_path__ + "edc6ec3b40fde370cfa3a82afb0fb9b4.svg";